import type { MediaLibraryFormProps } from '../app/interfaces'

export const convertDefaultUploadParameters = (values: any): MediaLibraryFormProps => {
  let fileObject: MediaLibraryFormProps = {}

  if (values?.extensions?.length)
    fileObject = { ...fileObject, extensions: values?.extensions }

  // Add saved extensions - keep them separate for UI and also merge into extensions for upload
  if (values?.savedExtensions?.length) {
    // Keep savedExtensions separate for the UI (checkboxes)
    fileObject = { ...fileObject, savedExtensions: values.savedExtensions }
    
    // Also merge into extensions for backward compatibility
    if (fileObject.extensions) {
      fileObject.extensions = [...fileObject.extensions, ...values.savedExtensions]
    } else {
      fileObject.extensions = values.savedExtensions
    }
  }

  if (
    values &&
    (values?.customCoordinates?.['x-coordinate'] ||
      values?.customCoordinates?.['y-coordinate'] ||
      values?.customCoordinates?.height ||
      values?.customCoordinates?.width)
  )
    fileObject = {
      ...fileObject,
      customCoordinates: `${values?.customCoordinates['x-coordinate']},${values?.customCoordinates['y-coordinate']},${values?.customCoordinates.width},${values?.customCoordinates?.height}`,
    }

  if (values?.customMetadata && Array.isArray(values?.customMetadata)) {
    fileObject = {
      ...fileObject,
      customMetadata: values?.customMetadata?.reduce(
        (ob, data) => ({ ...ob, ...data }),
        {},
      ),
    }
  }
  if (values && Object.keys(values)?.includes('uniqueFileNameOnUpload')) {
    fileObject = {
      ...fileObject,
      useUniqueFileName:
        values?.uniqueFileNameOnUpload === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('isPrivateFile')) {
    fileObject = {
      ...fileObject,
      isPrivateFile: values?.isPrivateFile === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('publishFileOnUpload')) {
    fileObject = {
      ...fileObject,
      isPublished: values?.publishFileOnUpload === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('overwriteFile')) {
    fileObject = {
      ...fileObject,
      overwriteFile: values?.overwriteFile === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('overwriteTags')) {
    fileObject = {
      ...fileObject,
      overwriteTags: values?.overwriteTags === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('overwriteDescription')) {
    fileObject = {
      ...fileObject,
      overwriteDescription: values?.overwriteDescription === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('overwriteAITags')) {
    fileObject = {
      ...fileObject,
      overwriteAITags: values?.overwriteAITags === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('overwriteCustomMetadata')) {
    fileObject = {
      ...fileObject,
      overwriteCustomMetadata:
        values?.overwriteCustomMetadata === 'true' ? true : false,
    }
  }
  if (values && Object.keys(values)?.includes('preTransformation')) {
    fileObject = { ...fileObject, preTransformation: values?.preTransformation }
  }
  if (values && Object.keys(values)?.includes('postTransformation')) {
    fileObject = { ...fileObject, postTransformation: values?.postTransformation }
  }
  return fileObject
}
